import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"

export interface ReviewProps {
  author?: string
  fiveStars?: boolean
  image?: string
  info?: string
  reviewCTA?: string
  tapEnabled?: boolean
  text: string
  url?: string
}

const Review: React.FC<ReviewProps> = ({
  author,
  fiveStars,
  image,
  info,
  reviewCTA,
  tapEnabled,
  text,
  url,
}) => {
  return (
    <div
      className={cx({
        [styles.review]: true,
        [styles.tapEnabled]: tapEnabled,
        [styles.withImage]: image,
      })}
    >
      {/* eslint-disable-next-line */}
      {url && <a href={url} className={styles.tapLink} />}
      <blockquote className={styles.blockquote} cite={url}>
        <div className={styles.quoteMarkWrapper}>
          <i
            className={cx({
              [styles.quoteMark]: true,
              ["bsk-icon-quote"]: true,
            })}
          />
        </div>
        <div className={styles.textWrapper}>
          <p className={styles.text}>{text}</p>
          <div className={styles.linkWrapper}>
            {url && (
              <a className={styles.link} href={url}>
                <span className="bet-LinkUnderline">
                  {reviewCTA || "See review on Google"}
                </span>
              </a>
            )}
            <cite className={styles.cite}>
              {fiveStars && (
                <div className={styles.starsContainer}>
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                  <i
                    className={cx({
                      [styles.star]: true,
                      ["bsk-icon-star-fill"]: true,
                    })}
                  />
                </div>
              )}
              {author && <p className={styles.author}>{author}</p>}
              {info && <p className={styles.info}>{info}</p>}
            </cite>
          </div>
        </div>
      </blockquote>
    </div>
  )
}

export default Review
